import React from 'react';
import { Input } from "antd";
import "./styles.css";

const formatNumber = (value) => new Intl.NumberFormat().format(value);

export const NumericInput = (props) => {
    const { value, onChange, flagselection, changesflag, setcustomMessage } = props;

    const handleChange = (e) => {
        const { value: inputValue } = e.target;
            const inputPhoneNumber = inputValue;    
            // Remove non-numeric characters
            const cleanedPhoneNumber = inputPhoneNumber.replace(/\D/g, '');

            // Apply the phone number format
            let formattedPhoneNumber = '';
            if (cleanedPhoneNumber.length > 0) {
            formattedPhoneNumber += '(' + cleanedPhoneNumber.substring(0, 3);
            }
            if (cleanedPhoneNumber.length >= 4) {
                formattedPhoneNumber += ')' + cleanedPhoneNumber.substring(3, 3);
                }
            if (cleanedPhoneNumber.length >= 4) {
            formattedPhoneNumber += ' ' + cleanedPhoneNumber.substring(3, 6);
            }
            if (cleanedPhoneNumber.length >= 7) {
            formattedPhoneNumber += '-' + cleanedPhoneNumber.substring(6, 10);
            }

            onChange(formattedPhoneNumber);
            changesflag(true);

        if (inputValue?.length <= 9){
            setcustomMessage(true);
        }

    }; // '.' at the end or only '-' in the input box.

    const handleBlur = () => {
        let valueTemp = value;

        if (value.charAt(value.length - 1) === '.' || value === '-') {
            valueTemp = value.slice(0, -1);
        }

        onChange(valueTemp.replace(/0*(\d+)/, '$1'));
    };

    const title = value ? (
        <span className="numeric-input-title">{value !== '-' ? formatNumber(Number(value)) : '-'}</span>
    ) : (
        'Input a number'
    );
    return (
            <Input
            className='number-div'
            {...props}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Enter your mobile number"
            addonBefore={flagselection}
            />        
    );
};
